<template>
  <t-form labelWidth="100px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm"/>
    <t-form-item label="加粗">
      <t-radio-group v-model="attribute.fontWeight" size="small">
        <t-radio-button value="lighter">更细</t-radio-button>
        <t-radio-button value="normal">正常</t-radio-button>
        <t-radio-button value="bold">加粗</t-radio-button>
      </t-radio-group>
    </t-form-item>
    <t-form-item label="最小文字">
      <t-input-number size="small" v-model="attribute.sizeRange[0]" :min="4" :max="90" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="最大文字">
      <t-input-number size="small" v-model="attribute.sizeRange[1]" :min="10" :max="200" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="间距">
      <t-input-number size="small" v-model="attribute.gridSize" :min="0" :max="200" :decimal-places="0" :step="2"/>
    </t-form-item>
    <t-form-item label="旋转步长">
      <t-input-number size="small" v-model="attribute.rotationStep" :min="-90" :max="90" :decimal-places="0" :step="5"/>
    </t-form-item>
    <!-- <t-form-item label="聚焦">
      <t-switch v-model="attribute.emphasis.focus" :label="['开', '关']" size="small"/>
    </t-form-item>
    <t-form-item label="溢出显示">
      <t-switch v-model="attribute.drawOutOfBound" :label="['是', '否']" size="small"/>
    </t-form-item>
    <t-form-item label="收缩文本">
      <t-switch v-model="attribute.shrinkToFit" :label="['开', '关']" size="small"/>
    </t-form-item>
    <t-form-item label="保持maskImage的宽高比或1:1的形状">
      <t-switch v-model="attribute.keepAspect" :label="['开', '关']" size="small"/>
    </t-form-item>-->
    <t-form-item label="形状">
      <!-- <e-shape-select v-model="attribute.maskImage" :base64="true"/>-->
      <t-select v-model="attribute.shape" size="small">
        <t-option label="圆形(默认)" value="circle"/>
        <t-option label="心形" value="cardioid"/>
        <t-option label="菱形" value="diamond"/>
        <t-option label="三角形" value="triangle"/>
        <t-option label="五边形" value="pentagon"/>
        <t-option label="星形" value="star"/>
      </t-select>
    </t-form-item>
    <t-form-item label="配色">
      <e-color-group v-model="attribute.color" :max="20" :gradient="false"/>
    </t-form-item>
  </t-form>
</template>

<script setup>
import { ref } from 'vue';
import EColorGroup from "@/components/designer/e-color-group.vue";
import CptData from '@/components/element/options/comp/cpt-data'
const props = defineProps({
  attribute:Object,
  cptDataForm:Object,
})
const currentComponent = ref('CptData');
</script>

<style scoped>

</style>